import * as ELIcon from '@element-plus/icons-vue';
const transElIconName = iconName => {
  return `icon${iconName}`.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`);
};
export default (app => {
  Object.keys(ELIcon).forEach(key => {
    app.component(transElIconName(key), ELIcon[key]);
  });
});